import { Component, Input } from '@angular/core';
import { IError } from '../../interfaces/error.interface';

@Component({
  standalone: false,
  selector: 'suvo-error-list',
  templateUrl: './error-list.component.html',
  styleUrls: ['./error-list.component.scss'],
})
export class ErrorListComponent {
  @Input() errors: Array<IError>;
}
